import {exportarHelper, useBuscarHelper, useReporteHelper} from "../../../Commons/Scripts/Utils/webservice-helper.js";
import mapearBalanceComprobacion from "../../../Contabilidad/Scripts/Utils/mapear-balance-comprobacion.js";
import React, {useState, useEffect } from 'react'
import {URL_EXPORTAR_TIENDA_DATAGRID} from "../../../Facturacion/Scripts/Utils/constantes";
export const URL_MAYOR_GENERAL = "/Contabilidad/WebService/ContabilidadWebService.asmx/ReporteMayorGeneral";
export const URL_BALANCE_GENERAL = "/Contabilidad/WebService/ContabilidadWebService.asmx/ReporteBalanceGeneral";
export const URL_PERIODOS_FISCALES = "/Contabilidad/WebService/ContabilidadWebService.asmx/PeriodosFiscales";
export const URL_PERIODOS_CONTABLES = "/Contabilidad/WebService/ContabilidadWebService.asmx/PeriodosContables";
export const URL_CUENTAS_CONTABLES = "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarCuentas";
export const URL_DIARIO_RAZON = "/Contabilidad/WebService/ContabilidadWebService.asmx/DiarioRazon";
export const URL_IMPRIMIR_BALANCE_GENERAL =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/ImprimirReporteBalanceGeneral";
export const URL_IMPRIMIR_MAYOR_GENERAL =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/ImprimirReporteMayorGeneral";
export const URL_EXPRESADO_EN = "/Contabilidad/WebService/ContabilidadWebService.asmx/ExpresadoEn";
export const URL_FUENTES_DOCUMENTO_MAYOR_GENERAL =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/FuentesDocumentoMayorGeneral";

/* balance comprobacion */
export const URL_BALANCE_COMPROBACION =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/ReporteBalanceComprobacion";

/* estado de resultado */
export const URL_ESTADO_RESULTADO = "/Contabilidad/WebService/ContabilidadWebService.asmx/ReporteEstadoResultado";
export const URL_ESTADO_RESULTADO_COMPARATIVO =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/ReporteEstadoResultadoComparativo";
export const URL_DASHBOARD_TARJETAS = "/Contabilidad/WebService/ContabilidadWebService.asmx/buscarTarjetasDashboard";
export const URL_DASHBOARD_GRAFICO_GASTOS_TIPO_SUPLIDOR =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarGraficoGastosPorTipoSuplidorDashboard";
export const URL_DASHBOARD_GRAFICO_GASTOS_TIPO_GASTO =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarGraficoGastosPorTipoGastoDashboard";
export const URL_DASHBOARD_GRAFICO_GASTOS_CONCEPTO =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarGraficoGastosPorConceptoDashboard";
export const URL_DASHBOARD_GRAFICO_GASTOS_FORMA_PAGO =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarGraficoGastosPorFormaPagoDashboard";
export const URL_DASHBOARD_GRAFICO_GASTOS_TOTAL =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarGraficoGastosTotalDashboard";
export const URL_DASHBOARD_GRAFICO_GASTOS_TASA_GASTO =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarGraficoGastosTasaGastoDashboard";
export const URL_DASHBOARD_TOPS10 = "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarTops10Dashboard";

export const URL_DASHBOARD_GRAFICO_MARGEN_NETO =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarGraficoMargenNetoDashboard";
export const URL_DASHBOARD_GRAFICO_MARGEN_BRUTO =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarGraficoMargenBrutoDashboard";
export const URL_DASHBOARD_GRAFICO_MARGEN_OPERATIVO =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarGraficoMargenOperativoDashboard";

export const URL_DASHBOARD_GRID_CENTROS =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarCentrosGridDashboard";

export const URL_DASHBOARD_CENTROS_AUTOCOMPLETE =
  "/Contabilidad/WebService/ContabilidadWebService.asmx/BuscarListadoCentros";

export const URL_EXPORTAR_CENTROS_GRID = "/Contabilidad/WebService/ContabilidadWebService.asmx/ExportarExcel";
export const useObtenerGraficoMargenOperativoDashboard = (cuerpo) => {
  const url = URL_DASHBOARD_GRAFICO_MARGEN_OPERATIVO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerGraficoMargenBrutoDashboard = (cuerpo) => {
  const url = URL_DASHBOARD_GRAFICO_MARGEN_BRUTO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerGraficoMargenNetoDashboard = (cuerpo) => {
  const url = URL_DASHBOARD_GRAFICO_MARGEN_NETO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useBuscarCentrosAutoComplete = (cuerpo) => {
  const url = URL_DASHBOARD_CENTROS_AUTOCOMPLETE;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerGridCentrosDashboard = (cuerpo) => {
  const url = URL_DASHBOARD_GRID_CENTROS;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerGraficosMargenes = (cuerpo) => {
  const url = URL_DASHBOARD_GRAFICOS_MARGENES;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerTarjetasDashboard = (cuerpo) => {
  const url = URL_DASHBOARD_TARJETAS;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useBuscarTop10Dashboard = (cuerpo) => {
  const url = URL_DASHBOARD_TOPS10;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerGraficoGastosTasaGastoDashboard = (cuerpo) => {
  const url = URL_DASHBOARD_GRAFICO_GASTOS_TASA_GASTO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerGraficoGastosTotalDashboard = (cuerpo) => {
  const url = URL_DASHBOARD_GRAFICO_GASTOS_TOTAL;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerGraficoGastosPorFormaPagoDashboard = (cuerpo) => {
  const url = URL_DASHBOARD_GRAFICO_GASTOS_FORMA_PAGO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerGraficoGastosPorConceptoDashboard = (cuerpo) => {
  const url = URL_DASHBOARD_GRAFICO_GASTOS_CONCEPTO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerGraficoGastosPorTipoSuplidorDashboard = (cuerpo) => {
  const url = URL_DASHBOARD_GRAFICO_GASTOS_TIPO_SUPLIDOR;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerGraficoGastosPorTipoGastoDashboard = (cuerpo) => {
  const url = URL_DASHBOARD_GRAFICO_GASTOS_TIPO_GASTO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return { data, loading, error };
};

export const useObtenerBalanceGeneral = (cuerpo) => {
  const url = URL_BALANCE_GENERAL;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);

  return { data, loading, error };
};

export const useObtenerMayorGeneral = (cuerpo) => {
  const { data, loading, error } = useBuscarHelper(URL_MAYOR_GENERAL, cuerpo);

  return { data: data?.Resultados, loading, error };
};

export const useObtenerPeriodosContables = (cuerpo) => {
  const url = URL_PERIODOS_CONTABLES;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);

  return { data, loading, error };
};

export const useObtenerPeriodosFiscales = () => {
  const url = URL_PERIODOS_FISCALES;
  const { data, loading, error } = useBuscarHelper(url);

  return { data, loading, error };
};

export const useObtenerCuentas = (cuerpo) => {
  const url = URL_CUENTAS_CONTABLES;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);

  return { data, loading, error };
};

export const useObtenerDiarioRazon = () => {
  const url = URL_DIARIO_RAZON;
  const { data, loading, error } = useBuscarHelper(url);

  return { data, loading, error };
};

export const useExpresadoEn = () => {
  const url = URL_EXPRESADO_EN;
  const { data, loading, error } = useBuscarHelper(url);

  return { data, loading, error };
};

export const useFuentesDocumento = () => {
  const url = URL_FUENTES_DOCUMENTO_MAYOR_GENERAL;
  const { data, loading, error } = useBuscarHelper(url);

  return { data, loading, error };
};

/* balance-comprobacion */

export const useObtenerBalanceComprobacion = (where) => {
  const { data, loading, error } = useBuscarHelper(URL_BALANCE_COMPROBACION, where);

  const resultados = data?.Resultados?.Cuentas == null ? [] : mapearBalanceComprobacion(data?.Resultados?.Cuentas);

  return { data: resultados, loading, error };
};

export const useObtenerBalanceComprobacionDetalle = (where) => {
  const { data, loading, error } = useBuscarHelper(URL_BALANCE_COMPROBACION, where);

  const resultados = data?.Resultados?.Cuentas == null ? [] : data?.Resultados?.Cuentas;

  return { data: resultados, loading, error };
};

export const useObtenerPeriodosContablesV2 = (where) => {
  const url = URL_PERIODOS_CONTABLES;
  const [cuerpo, setCuerpo] = useState({ where: {} });

  const { data, loading, error } = useBuscarHelper(url, cuerpo);

  const resultados = mapearSelect(data?.Resultados);

  useEffect(() => {
    setCuerpo({ where: { ...where } });
  }, [where]);

  return { data: resultados, loading, error };
};

export const useObtenerPeriodosFiscalesV2 = () => {
  const url = URL_PERIODOS_FISCALES;
  const { data, loading, error } = useBuscarHelper(url);

  const resultados = mapearSelect(data?.Resultados);

  return { data: resultados, loading, error };
};

export const useExpresadoEnV2 = () => {
  const url = URL_EXPRESADO_EN;
  const { data, loading, error } = useBuscarHelper(url);

  const resultados = data?.Resultados;

  return { data: resultados, loading, error };
};

export const useObtenerCuentasV2 = () => {
  const url = URL_CUENTAS_CONTABLES;
  const [cuerpo, setCuerpo] =useState({ where: { EsPaginable: false } });

  const { data, loading, error } = useBuscarHelper(url, cuerpo);

  const resultados = mapearSelect(data?.Resultados, "IdentificadorCuenta", "Nombre");

  return { data: resultados, loading, error };
};

export const useFuentesDocumentoV2 = () => {
  const url = URL_FUENTES_DOCUMENTO_MAYOR_GENERAL;
  const { data, loading, error } = useBuscarHelper(url);

  const resultados = data?.Resultados;

  return { data: resultados, loading, error };
};

export const useObtenerDiarioRazonV2 = () => {
  const url = URL_DIARIO_RAZON;
  const { data, loading, error } = useBuscarHelper(url);

  const resultados = data?.Resultados ?? [];

  return { data: [], loading, error };
};

/* estado de resultado */

export function useObtenerEstadoResultado(where) {
  const url = URL_ESTADO_RESULTADO;
  const [cuerpo, setCuerpo] = useState();

  useEffect(() => {
    if (where) {
      setCuerpo({ where: { ...where } });
    }
  }, [where]);

  const { data, loading, error } = useBuscarHelper(url, where);

  const resultados = data?.Resultados?.Cuentas.map((c) => ({
    ...c,
    BalancePeriodoActual: c.Grupo === "X" || c.Grupo === "G" ? c.BalancePeriodoActual * -1 : c.BalancePeriodoActual,
  }));

  const ingresosOperativos = resultados
    ?.filter((c) => c.Grupo === "I" && c.EsOperativo === true)
    .map((c, i) => {
      return { data: { ...c }, key: `0-${i}` };
    });

  const costosOperativos = resultados
    ?.filter((c) => c.Grupo === "X")
    .map((c, i) => {
      return { data: { ...c }, key: `1-${i}` };
    });

  const gastosGeneralesAdministrativos = resultados
    ?.filter((c) => c.Grupo === "G" && c.EsOperativo === true)
    .map((c, i) => ({ data: { ...c }, key: `3-${i}` }));

  const ingresoGastosNoOperativos = resultados
    ?.filter((c) => (c.Grupo === "G" || c.Grupo === "I") && c.EsOperativo !== true)
    .map((c, i) => ({ data: { ...c }, key: `5-${i}` }));

  const impuestos = resultados
    ?.filter((c) => c.EsISR === true)
    .map((c, i) => ({
      data: { ...c },
      key: `7-${i}`,
    }));

  function sumPropiedad(list, propertyKey) {
    return list?.reduce((a, b) => a + b.data[propertyKey], 0);
  }

  const totalIngresosOperativos = sumPropiedad(ingresosOperativos, "BalancePeriodoActual");

  const totalCostosOperativos = sumPropiedad(costosOperativos, "BalancePeriodoActual");

  const totalGastosGeneralesAdministrativos = sumPropiedad(gastosGeneralesAdministrativos, "BalancePeriodoActual");

  const totalIngresoGastosNoOperativos = sumPropiedad(ingresoGastosNoOperativos, "BalancePeriodoActual");

  const respuesta = [];

  if (ingresosOperativos?.length > 0) {
    respuesta.push({
      key: "0",
      data: {
        IdentificadorCuenta: "0",
        CuentaDesc: "Ingresos Operativos",
        BalancePeriodoActual: totalIngresosOperativos,
      },
      children: ingresosOperativos
        ? [
            ...ingresosOperativos,
            {
              key: `0-${ingresosOperativos?.length}`,
              data: {
                IdentificadorCuenta: "Subtotal",
                CuentaDesc: "Total Ingresos Operativos",
                BalancePeriodoActual: totalIngresosOperativos,
              },
            },
          ]
        : [],
    });
  }

  if (costosOperativos?.length > 0) {
    respuesta.push({
      key: "1",
      data: {
        IdentificadorCuenta: "1",
        CuentaDesc: "Costos Operativos",
        BalancePeriodoActual: totalCostosOperativos,
      },
      children: costosOperativos
        ? [
            ...costosOperativos,
            {
              key: `1-${costosOperativos?.length}`,
              data: {
                IdentificadorCuenta: "Subtotal",
                CuentaDesc: "Total Costos Operativos",
                BalancePeriodoActual: totalCostosOperativos,
              },
            },
          ]
        : [],
    });
  }

  const utilidadBruta = totalIngresosOperativos + totalCostosOperativos;

  if (utilidadBruta && utilidadBruta !== 0) {
    const utilidad = {
      key: "2",
      data: {
        IdentificadorCuenta: "Subtotal",
        CuentaDesc: "Total Resultado Bruto",
        BalancePeriodoActual: utilidadBruta,
      },
      children: [],
    };

    respuesta.push(utilidad);
  }

  if (gastosGeneralesAdministrativos?.length > 0) {
    respuesta.push({
      key: "3",
      data: {
        IdentificadorCuenta: "3",
        CuentaDesc: "Gastos Generales y Administrativos",
        BalancePeriodoActual: totalGastosGeneralesAdministrativos,
      },
      children: gastosGeneralesAdministrativos
        ? [
            ...gastosGeneralesAdministrativos,
            {
              key: `3-${gastosGeneralesAdministrativos?.length}`,
              data: {
                IdentificadorCuenta: "Subtotal",
                CuentaDesc: "Total Gastos Generales y Administrativos",
                BalancePeriodoActual: totalGastosGeneralesAdministrativos,
              },
            },
          ]
        : [],
    });
  }

  const totalResultadoOperativo = utilidadBruta + totalGastosGeneralesAdministrativos;
  if (totalResultadoOperativo && totalResultadoOperativo !== 0) {
    const total = {
      key: "4",
      data: {
        IdentificadorCuenta: "Subtotal",
        CuentaDesc: "Total Resultado Operativo (U.A.I.I)",
        BalancePeriodoActual: totalResultadoOperativo,
      },
      children: [],
    };
    respuesta.push(total);
  }

  if (ingresoGastosNoOperativos?.length > 0) {
    respuesta.push({
      key: "5",
      data: {
        IdentificadorCuenta: "5",
        CuentaDesc: "Ingresos y Gastos No Operativos",
        BalancePeriodoActual: totalIngresoGastosNoOperativos,
      },
      children: ingresoGastosNoOperativos
        ? [
            ...ingresoGastosNoOperativos,
            {
              key: `5-${ingresoGastosNoOperativos?.length}`,
              data: {
                IdentificadorCuenta: "Subtotal",
                CuentaDesc: "Total Ingresos y Gastos No Operativos",
                BalancePeriodoActual: totalIngresoGastosNoOperativos,
              },
            },
          ]
        : [],
    });
  }

  const totalResultadoNoOperativo = totalResultadoOperativo + totalIngresoGastosNoOperativos;
  if (totalResultadoNoOperativo && totalResultadoNoOperativo !== 0) {
    const total = {
      key: "6",
      data: {
        IdentificadorCuenta: "Subtotal",
        CuentaDesc: "Total Resultado Antes Impuesto (U.A.I)",
        BalancePeriodoActual: totalResultadoNoOperativo,
      },
      children: [],
    };
    respuesta.push(total);
  }

  if (impuestos?.length > 0) {
    respuesta.push({
      key: "7",
      data: {
        IdentificadorCuenta: "7",
        CuentaDesc: "Impuestos",
      },
      children: impuestos,
    });
  }

  const resultadoPeriodo = totalResultadoNoOperativo;

  if (resultadoPeriodo && resultadoPeriodo !== 0) {
    const total = {
      key: "8",
      data: {
        IdentificadorCuenta: "Total",
        CuentaDesc: "Resultado del Periodo",
        BalancePeriodoActual: resultadoPeriodo,
      },
      children: [],
    };

    respuesta.push(total);
  }

  return { data: respuesta, loading, error };
}

export const useObtenerEstadoResultadoComparativo = (where) => {
  const url = URL_ESTADO_RESULTADO_COMPARATIVO;
  const [cuerpo, setCuerpo] = useState({
    where: {},
  });

  const { data, loading, error } = useBuscarHelper(url, cuerpo);

  useEffect(() => {
    if (where) {
      setCuerpo({ where: { ...where } });
    }
  }, [where]);

  const columnas = data?.Resultados ? [...data.Resultados.map((item) => item?.respuesta?._NombrePeriodoActual)] : [];

  let mapa = [];

  if (data?.Resultados) {
    const datos = [];
    data?.Resultados.flatMap((c) => c.respuesta.Cuentas).forEach((c) => {
      if (!datos.some((cuenta) => cuenta.IdentificadorCuenta === c.IdentificadorCuenta)) {
        datos.push(c);
      }
    });

    mapa = datos.map((d, index) => {
      const balances = data.Resultados.map((resultado, index) => {
        const cuenta = resultado.respuesta.Cuentas.find((c) => c.IdentificadorCuenta === d.IdentificadorCuenta);
        return cuenta
          ? {
              [`Balance${index}`]:
                cuenta.Grupo === "X" || cuenta.Grupo === "G"
                  ? cuenta.BalancePeriodoActual * -1
                  : cuenta.BalancePeriodoActual,
            }
          : { [`Balance${index}`]: 0 };
      });

      return {
        ...d,
        ...Object.assign({}, ...balances),
      };
    });
  }

  const ingresosOperativos = mapa
    ?.filter((c) => c.Grupo === "I" && c.EsOperativo === true)
    .map((c, i) => {
      return { data: { ...c }, key: `0-${i}` };
    });

  const costosOperativos = mapa
    ?.filter((c) => c.Grupo === "X")
    .map((c, i) => {
      return { data: { ...c }, key: `1-${i}` };
    });

  const gastosGeneralesAdministrativos = mapa
    ?.filter((c) => c.Grupo === "G" && c.EsOperativo === true)
    .map((c, i) => ({ data: { ...c }, key: `3-${i}` }));

  const ingresoGastosNoOperativos = mapa
    ?.filter((c) => (c.Grupo === "G" || c.Grupo === "I") && c.EsOperativo !== true)
    .map((c, i) => ({ data: { ...c }, key: `5-${i}` }));

  const impuestos = mapa?.filter((c) => c.EsISR === true).map((c, i) => ({ data: { ...c }, key: `7-${i}` }));

  function sumPropiedad(list, propertyKey) {
    return list?.reduce((a, b) => a + b.data[propertyKey], 0);
  }

  let totalIngresosOperativos = {};

  if (ingresosOperativos?.length > 0) {
    Object.keys(ingresosOperativos[0].data).forEach((key) => {
      if (key.startsWith("Balance")) {
        totalIngresosOperativos[key] = sumPropiedad(ingresosOperativos, key);
      }
    });
  }

  let totalCostosOperativos = {};

  if (costosOperativos?.length > 0) {
    Object.keys(costosOperativos[0].data).forEach((key) => {
      if (key.startsWith("Balance")) {
        totalCostosOperativos[key] = sumPropiedad(costosOperativos, key);
      }
    });
  }

  let totalGastosGeneralesAdministrativos = {};

  if (gastosGeneralesAdministrativos?.length > 0) {
    Object.keys(gastosGeneralesAdministrativos[0].data).forEach((key) => {
      if (key.startsWith("Balance")) {
        totalGastosGeneralesAdministrativos[key] = sumPropiedad(gastosGeneralesAdministrativos, key);
      }
    });
  }

  let totalIngresoGastosNoOperativos = {};

  if (ingresoGastosNoOperativos?.length > 0) {
    Object.keys(ingresoGastosNoOperativos[0].data).forEach((key) => {
      if (key.startsWith("Balance")) {
        totalIngresoGastosNoOperativos[key] = sumPropiedad(ingresoGastosNoOperativos, key);
      }
    });
  }

  const respuesta = [];

  if (ingresosOperativos?.length > 0) {
    respuesta.push({
      key: "0",
      data: {
        IdentificadorCuenta: "0",
        CuentaDesc: "Ingresos Operativos",
        ...totalIngresosOperativos,
      },
      children: ingresosOperativos
        ? [
            ...ingresosOperativos,
            {
              key: `0-${ingresosOperativos?.length}`,
              data: {
                IdentificadorCuenta: "Subtotal",
                CuentaDesc: "Total Ingresos Operativos",
                ...totalIngresosOperativos,
              },
            },
          ]
        : [],
    });
  }

  if (costosOperativos?.length > 0) {
    respuesta.push({
      key: "1",
      data: {
        IdentificadorCuenta: "1",
        CuentaDesc: "Costos Operativos",
        ...totalCostosOperativos,
      },
      children: costosOperativos
        ? [
            ...costosOperativos,
            {
              key: `1-${costosOperativos.length}`,
              data: {
                IdentificadorCuenta: "Subtotal",
                CuentaDesc: "Total Costos Operativos",
                ...totalCostosOperativos,
              },
            },
          ]
        : [],
    });
  }

  let utilidadBruta = {};

  if (costosOperativos?.length > 0 || ingresosOperativos?.length > 0) {
    Object.keys(totalIngresosOperativos).forEach((key) => {
      utilidadBruta[key] = (utilidadBruta[key] || 0) + totalIngresosOperativos[key];
    });

    Object.keys(totalCostosOperativos).forEach((key) => {
      utilidadBruta[key] = (utilidadBruta[key] || 0) + totalCostosOperativos[key];
    });
  }

  if (costosOperativos?.length > 0 || ingresosOperativos?.length > 0) {
    const utilidad = {
      key: "2",
      data: {
        IdentificadorCuenta: "Subtotal",
        CuentaDesc: "Total Resultado Bruto",
        ...utilidadBruta,
      },
    };

    respuesta.push(utilidad);
  }

  if (gastosGeneralesAdministrativos?.length > 0) {
    respuesta.push({
      key: "3",
      data: {
        IdentificadorCuenta: "3",
        CuentaDesc: "Gastos Generales y Administrativos",
        ...totalGastosGeneralesAdministrativos,
      },
      children: gastosGeneralesAdministrativos
        ? [
            ...gastosGeneralesAdministrativos,
            {
              key: `3-${gastosGeneralesAdministrativos?.length}`,
              data: {
                IdentificadorCuenta: "Subtotal",
                CuentaDesc: "Total Gastos Generales y Administrativos",
                ...totalGastosGeneralesAdministrativos,
              },
            },
          ]
        : [],
    });
  }

  let totalResultadoOperativo = {};

  if (gastosGeneralesAdministrativos?.length > 0) {
    Object.keys(utilidadBruta).forEach((key) => {
      totalResultadoOperativo[key] = (totalResultadoOperativo[key] || 0) + utilidadBruta[key];
    });

    Object.keys(totalGastosGeneralesAdministrativos).forEach((key) => {
      totalResultadoOperativo[key] = (totalResultadoOperativo[key] || 0) + totalGastosGeneralesAdministrativos[key];
    });
  }

  if (gastosGeneralesAdministrativos?.length > 0) {
    const total = {
      key: "4",
      data: {
        IdentificadorCuenta: "Subtotal",
        CuentaDesc: "Total Resultado Operativo (U.A.I.I)",
        ...totalResultadoOperativo,
      },
    };

    respuesta.push(total);
  }

  if (ingresoGastosNoOperativos?.length > 0) {
    respuesta.push({
      key: "5",
      data: {
        IdentificadorCuenta: "5",
        CuentaDesc: "Ingresos y Gastos No Operativos",
        ...totalIngresoGastosNoOperativos,
      },
      children: ingresoGastosNoOperativos
        ? [
            ...ingresoGastosNoOperativos,
            {
              key: `5-${ingresoGastosNoOperativos?.length}`,
              data: {
                IdentificadorCuenta: "Subtotal",
                CuentaDesc: "Total Ingresos y Gastos No Operativos",
                ...totalIngresoGastosNoOperativos,
              },
            },
          ]
        : [],
    });
  }

  let totalResultadoNoOperativo = {};

  if (ingresoGastosNoOperativos?.length > 0) {
    Object.keys(totalResultadoOperativo).forEach((key) => {
      totalResultadoNoOperativo[key] = (totalResultadoNoOperativo[key] || 0) + totalResultadoOperativo[key];
    });

    Object.keys(totalIngresoGastosNoOperativos).forEach((key) => {
      totalResultadoNoOperativo[key] = (totalResultadoNoOperativo[key] || 0) + totalIngresoGastosNoOperativos[key];
    });
  }

  if (ingresoGastosNoOperativos?.length > 0) {
    const total = {
      key: "6",
      data: {
        IdentificadorCuenta: "Subtotal",
        CuentaDesc: "Total Resultado Antes Impuesto (U.A.I)",
        ...totalResultadoNoOperativo,
      },
    };

    respuesta.push(total);
  }

  if (impuestos?.length > 0) {
    respuesta.push({
      key: "7",
      data: {
        IdentificadorCuenta: "7",
        CuentaDesc: "Impuestos",
      },
      children: impuestos,
    });
  }

  const resultadoPeriodo = totalResultadoNoOperativo;

  if (mapa?.length > 0) {
    const total = {
      key: "8",
      data: {
        IdentificadorCuenta: "Total",
        CuentaDesc: "Resultado del Periodo",
        ...resultadoPeriodo,
      },
    };

    respuesta.push(total);
  }

  return { data: respuesta, columnas, loading, error };
};

function mapearSelect(items, valor = "IdSec", label = "Descripcion") {
  if (items === undefined || items === null) {
    return [];
  }

  return items.map((item) => ({
    value: item[valor],
    label: item[label],
  }));
}

export const exportarCentrosGrid = async (cuerpo) => {

    try {
        await exportarHelper(URL_EXPORTAR_CENTROS_GRID, cuerpo);
    } catch (error) {
        console.error("Falló la descarga del reporte:", error);
        alert("Ocurrió un error al generar el reporte. Por favor, intente de nuevo.");
    } finally {
        // Oculta el indicador de carga
        // document.getElementById('spinner').style.display = 'none';
    }
}